import { catchError, mergeMap, concatMap, startWith } from 'rxjs/operators';
import { from } from 'rxjs';
import { ofType } from 'redux-observable';

import { setLoader, handleErrors, setError } from './deps';
import { PORTRAIT_REQUEST } from './types';
import { portraitSuccess } from './actions';

const fetchPortrait = ($action, $state, { api }) => {
  const $apiPortrait = api.getModuleByName('portrait');

  return $action.pipe(
    ofType(PORTRAIT_REQUEST),
    mergeMap(action => {
      return from($apiPortrait.fetchAll()).pipe(
        concatMap(res => [portraitSuccess(res), setLoader(false)]),

        ...handleErrors(action),

        catchError(err => [setError(err.code, err.message, err), setLoader(false)]),

        startWith(setLoader(true))
      );
    })
  );
};

export default fetchPortrait;
